// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartGridFrontSideAction.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Report Part Grid Front Side Action
 */
import { get, getOr, includes, curry, compact, isEmpty } from 'lodash/fp';
import { compose, pure, withHandlers } from 'recompose';
import { GRID_STYLES } from 'logic/data/Izenda.ReportPartGridConstants';
import { SORT_ORDERS } from 'logic/data/Izenda.ReportPartFieldConstants';
import ReportPartUtils from 'share/utils/Izenda.ReportPartUtils';
import AppGlobal from 'Izenda.AppGlobal';

/**
 * on sort change
 * @param {Object} props properties
 * @param {Object} container container
 * @param {Object} fieldElement selected field
 * @param {String} oldSortValue old sort value
 * @param {Number} previewRecords user can change preview records number via API
 */
const onSortChange = (
  props: any,
  container: any,
  fieldElement: any,
  oldSortValue: String,
  previewRecords: Number,
  e: any
) => {
  const {
    reportPart,
    reportPart: { reportPartContent, isBackSide },
    reportPart: {
      reportPartContent: {
        properties: {
          generalInfo: { gridStyle }
        }
      }
    }
  } = props;
  const newSortValue = reportPartContent.getNewSortValue(container, oldSortValue, fieldElement);

  if (isBackSide || get('field.isRunningField', fieldElement)) {
    return false;
  }

  if (
    !AppGlobal.advancedSettings.other.multipleSortOnGridHeaderValue &&
    includes(gridStyle, [GRID_STYLES.VERTICAL.value, GRID_STYLES.HORIZONTAL.value])
  ) {
    reportPartContent.resetSortValue(container);
  }

  fieldElement.properties.setSortValue(newSortValue);
  props.needUpdatePreview(reportPart, null, null, null, null, previewRecords);
};

/**
 * resolve sorting value for selected field
 * @param {Object} props properties
 * @param {Object} container container
 * @param {Object} fieldElement selected field
 * @return {String} [sort value]
 */
const resolveSortValue = (props: any, container: any, fieldElement: any): String => {
  let sortValue = get('properties.dataFormattings.sort', fieldElement);
  const gridStyle = getOr('', 'reportPart.reportPartContent.properties.generalInfo.gridStyle', props);
  if (gridStyle === GRID_STYLES.VERTICAL.value || gridStyle === GRID_STYLES.HORIZONTAL.value) {
    const containerCollection = compact([
      props.reportPart.reportPartContent.columns,
      props.reportPart.reportPartContent.rows,
      props.reportPart.reportPartContent.values,
      props.reportPart.reportPartContent.separators
    ]);
    const canUnsort = ReportPartUtils.checkCanUnsort(gridStyle, container, fieldElement, containerCollection);
    if (!canUnsort && (isEmpty(sortValue) || sortValue === SORT_ORDERS.Unsorted.value)) {
      sortValue = SORT_ORDERS.ASC.value;
    }
  }
  return sortValue;
};

const action = compose(
  pure,
  withHandlers({
    onSortChange: curry(onSortChange),
    resolveSortValue: curry(resolveSortValue)
  })
);

export default action;



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartGrid/Izenda.ReportPartGridFrontSideAction.js